module.exports = __webpack_public_path__ + "img/cron-wallet.ad433cc0.svg";